import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-rain': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 128c53 0 96 43 96 96s-43 96-96 96h-320c-53 0-96-43-96-96 0-42.5 27.8-78.2 66.1-90.8-1.3-6.9-2.1-13.9-2.1-21.2 0-61.9 50.1-112 112-112 43.3 0 80.4 24.8 99 60.8 14.7-17.5 36.4-28.8 61-28.8 44.2 0 80 35.8 80 80 0 5.6-0.5 11-1.6 16.2 0.5 0 1-0.2 1.6-0.2zM88 374.2c2.5-8.5 13.8-8.1 16 0 12.8 44.6 40 56.3 40 87.7 0 27.7-21.5 50.1-48 50.1s-48-22.4-48-50.1c0-31.3 27.2-43.3 40-87.7zM248 374.2c2.5-8.5 13.8-8.1 16 0 12.8 44.6 40 56.3 40 87.7 0 27.7-21.5 50.1-48 50.1s-48-22.4-48-50.1c0-31.3 27.2-43.3 40-87.7zM408 374.2c2.5-8.5 13.8-8.1 16 0 12.8 44.6 40 56.3 40 87.7 0 27.7-21.5 50.1-48 50.1s-48-22.4-48-50.1c0-31.3 27.2-43.3 40-87.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-rain.js
// module id = 1209
// module chunks = 0